export default __webpack_public_path__ + "media/images/paylogos/gray/dotpay-813d7e58ed104e1325c2b45f3f00e20b.png";